import {
  INIT_CONNECTION,
  PRESCRIPTION_LOADING,
  GET_PRESCRIPTIONS,
  GET_PRESCRIPTIONS_BY_ID,
  GET_PRESCRIPTION_BY_NUMBER,
  GET_PRESCRIPTION_BY_STATUS,
  GET_DRAFT,
  GET_PENDING,
  GET_PRESCRIPTION_HISTORY,
  DISPENSED_NOTIFICTION,
  PRESCRIPTION_ARRIVED,
  NEW_MESSAGE,
  GET_DRAFTED,
  GET_PENDINGS,
  GET_APPROVED,
  INITIAL_LOAD,
  UPDATE_DATA,
  OPEN_CHAT,
  APPROVE_PRESCRIPTION_LOADING,
  GET_APPROVE_PRESCRIPTIONS,
  DISPENSE_PRESCRIPTION_LOADING,
  GET_DISPENSED_PRESCRIPTIONS,
  MODAL_PRESCRIPTION_VIEW,
  GET_DURINFO,
  START_VIDEO_CALL,
  OPEN_STORE_MODAL,
  START_COUNSEL_CALL, COUNSELLING_PRESCRIPTION_ARRIVED,

  Draft_prescription_view
} from "../actions/types";
import { getPrescriptions } from "../actions/mqttAction";
import Paho from "paho-mqtt";
import api from "../api";
import {
  messageArrive,
  prescriptionArrived,
  startCounsellingCall, counsellingPrescription
} from "../actions/mqttAction";
import store from "../index";
import decode from "jwt-decode";

import NotificationComponent from "../components/Notifications/NotificationComponent";
import { func } from "prop-types";

let orgId, role, branches;
// if(localStorage.jwtToken){
//   const decoded = decode(localStorage.jwtToken);
//   let orgId = decoded.orgId ;
//   let role =  decoded.roles[0];
//   let branches = decoded.branch;
// }
// else{
//   let orgId = 1 ;
//   let role =  "TECHNICIAN";
//   let branches = "Chama";
// }

var client;
let initialState = {
  err: null,
  orgId: null,
  prescriptionDetails: [],
  prescriptionsById: [],
  prescriptionByNumber: {},
  getPrescriptionByStatus: [],
  onMessageArrive: [],
  prescriptionArrived: {},
  prescriptionHistory: [],
  drafted: [],
  draftPrescriptions: [],
  pendingPrescriptions: [],
  approvedPrescriptions: [],
  dispensedPrescriptions: [],
  email: "",
  newMessage: {},
  approved_loading: false,
  dispensed_loading: false,
  loading: false,

  initial_load: true,
  data_update: true,
  open_chat: false,
  presc_modal_view: {},
  is_modal_view: false,
  durInfo: {},
  startVideoCall: false,
  show_store_view: false,
  start_counsel_call: {}

};
let orgID;
localStorage.orgID ? (orgID = localStorage.orgID) : (orgID = 1);
let branchName;
localStorage.branch
  ? (branchName = localStorage.branch)
  : (branchName = "Chama");

// connect the client

const createClient = () => {
  let clientID = "clientId" + new Date().getTime();
  client = new Paho.Client(
    process.env.REACT_APP_PAHO_CLIENT,
    Number(8083),
    clientID
  );
  // set callback handlers

  client.onConnectionLost = onConnectionLost;
  client.onConnected = onConnected;
  client.onMessageArrived = onMessageArrived;
  client.connect({
    cleanSession: false,
    useSSL: true,
    onSuccess: onConnect,
    onFailure: onFailure,
    userName: "telerx_qa",
    password: "2c7e0ba33c1e4b06",
    reconnect: true
  });
  return client;
};

// called when the client connects
function onConnect() {
  // let isAuthenticated = store.getState().auth.isAuthenticated;
  // !isAuthenticated ? console.log("User Not Logged In.....") : (this.connectToMqtt();)
  // Once a connection has been made, make a subscription and send a message.
  console.log("----Connected to MQTT----");
  store.dispatch({ type: INITIAL_LOAD, payload: true });
  let orgId, role, branches;
  if (localStorage.jwtToken) {
    let decoded = decode(localStorage.jwtToken);
    orgId = decoded.orgId;
    role = decoded.roles[0];
    branches = decoded.branch;
  } else {
    orgId = 1;
    role = "TECHNICIAN";
    branches = "Chama";
  }

  if (role === "PHARMACIST") {
    branches.map(branch => {
      console.log("----Connected to MQTT Pharma----" + branch);
      // client.subscribe(orgId +"_draft_prescription");
      // // client.subscribe(orgId + "_" + branch + "_dispense_prescription");
      // client.subscribe(orgId +  "_approved_prescription");
      // client.subscribe(orgId + "_pending_prescription");
      client.subscribe(orgId + "_" + branch + "_update_prescriptions_data");
      client.subscribe(orgId + "_" + branch + "_counselling_call");
    });
  } else {
    let decoded = decode(localStorage.jwtToken);
    // branches = decoded.branch[0];
    branches = localStorage.branch;
    console.log("----Connected to MQTT Tech----" + branches);
    // client.subscribe(orgId + "_" + branches + "_draft_prescription");
    // client.subscribe(orgId + "_" + branches + "_dispense_prescription");
    // client.subscribe(orgId + "_" + branches + "_approved_prescription");
    // client.subscribe(orgId + "_" + branches + "_pending_prescription");
    client.subscribe(orgId + "_" + branches + "_update_prescriptions_data");
  }

}
function onConnected(resObj) {
  console.log("Connected to " + resObj.uri);
  if (resObj.reconnect) {
    console.log("It was a result of automatic reconnect.");
  }
}
function onFailure() {
  console.log("connection failed ", arguments);
}

// called when the client loses its connection
function onConnectionLost(resObj) {
  console.log(
    "Lost connection to " +
    resObj.uri +
    "\nError code: " +
    resObj.errorCode +
    "\nError text: " +
    resObj.errorMessage
  );
  if (resObj.reconnect) {
    console.log("Automatic reconnect is currently active.");
  } else {
    alert("Lost connection to host.");
  }
}

// function startVideoCall() {
//   //console.log("==========Making Video Call=================")

//   let orgId, role, branches;
//   if (localStorage.jwtToken) {
//     let decoded = decode(localStorage.jwtToken);
//     orgId = decoded.orgId;
//     role = decoded.roles[0];
//     //branches = decoded.branch;
//   } else {
//     orgId = 1;
//     role = "TECHNICIAN";
//     //branches = "Chama";
//   }
//   let message1 = new Paho.Message(orgId + "_counselling_call");
//   message1.destinationName = orgId + "_counselling_call";
//   client.send(message1);
// }

// called when a message arrives
function onMessageArrived(message) {
  //let newMessage = JSON.parse(message.payloadString);
  //console.log("================New Message=============="+JSON.stringify(message))
  const roles = store.getState().auth.user.roles[0];
  let newMessage = JSON.parse(message.payloadString);

  if (newMessage.counselling_call) {
    if (roles === "PHARMACIST" && !newMessage.is_counselling_rejected) {
      //console.log("================New Message=============="+JSON.stringify(newMessage))
      const instance = new NotificationComponent();
      const result = instance.counsellingCallNotification(
        newMessage.prescription_number,
        newMessage.patientName,
        newMessage.no_of_prescs,
        newMessage.branchName,
        newMessage.room_name,
      );
      store.startcounselCall(newMessage);
    }
  } else {
    if (newMessage.rxInfo.rxStatus === "Dispensed") {
      store.dispatch(prescriptionArrived(newMessage));
    }
    else if (newMessage.rxInfo.rxStatus === "CounsellingPending") {
      //console.log("==========New Dispnse Presction===========")
      store.dispatch(counsellingPrescription(newMessage));
    }
    else {

      // api.prescriptions.getPrescriptions()
      //     .then(prescriptions => {
      //         prescriptions.unshift(newMessage);
      store.dispatch(messageArrive(newMessage));

      // });
    }

    if (
      newMessage.rxInfo.rxStatus === "Pending" &&
      roles === "PHARMACIST" &&
      newMessage.isEditing !== true
    ) {
      //console.log("=================Patient Waiting==============="+ newMessage.patientInfo.patientAdditionalInfo.patientWaiting )

      if (
        newMessage.patientInfo.patientAdditionalInfo.patientWaiting === true
      ) {
        const instance = new NotificationComponent();
        const result = instance.patientWaiting(
          newMessage.rxInfo.prescriptionNumber,
          newMessage.patientInfo.firstName + newMessage.patientInfo.lastName
        );
      }
      else {
        const instance = new NotificationComponent();
        const result = instance.reviewNotification(
          newMessage.rxInfo.prescriptionNumber
        );
      }
      //getPrescriptions(orgID);

      //store.dispatch(messageArrive(newMessage));
    }



    // if (
    //   newMessage.rxInfo.rxStatus === "Pending" &&
    //   roles === "TECHNICIAN" &&
    //   newMessage.isEditing === true &&
    //   newMessage.technicianId === store.getState().auth.user.sub
    // ) {
    //   const instance = new NotificationComponent();
    //   const result = instance.workingNotification(
    //     newMessage.rxInfo.prescriptionNumber,
    //     newMessage.pharmacistInfo.name
    //   );
    // }
    if (
      newMessage.rxInfo.rxStatus === "Approved" &&
      roles === "TECHNICIAN" &&
      newMessage.isEditing !== true &&
      newMessage.technicianId === store.getState().auth.user.sub
    ) {
      const instance = new NotificationComponent();
      const result = instance.approvedNotification(
        newMessage.rxInfo.prescriptionNumber,
        newMessage.pharmacistInfo.name
      );
    }
    if (
      newMessage.rxInfo.rxStatus === "Rejected" &&
      roles === "TECHNICIAN" &&
      newMessage.isEditing !== true &&
      newMessage.technicianId === store.getState().auth.user.sub
    ) {
      const instance = new NotificationComponent();
      const result = instance.rejectedNotification(
        newMessage.rxInfo.prescriptionNumber,
        newMessage.pharmacistInfo.name
      );
    }
    //store.dispatch(updatePrescriptions(newMessage));
    //store.dispatch(getPrescriptions());
  }
}

export default function mqttReducer(state = initialState, action = {}) {
  switch (action.type) {
    case INIT_CONNECTION:
      return {
        ...state,
        client: createClient()
      };
    case INITIAL_LOAD:
      return {
        ...state,
        initial_load: action.payload
      };

    case START_COUNSEL_CALL:
      return {
        ...state,
        start_counsel_call: action.payload
      };
    case OPEN_CHAT:
      return {
        ...state,
        open_chat: action.payload
      };

    case OPEN_STORE_MODAL:
      //console.log("==========Making store Call=================")
      return {
        ...state,
        show_store_view: action.payload
      };

    case START_VIDEO_CALL:
      //console.log("==========Making Video Call=================")
      let orgId, role, branches;
      if (localStorage.jwtToken) {
        let decoded = decode(localStorage.jwtToken);
        orgId = decoded.orgId;
        role = decoded.roles[0];
        //branches = decoded.branch;
      } else {
        orgId = 1;
        role = "TECHNICIAN";
        //branches = "Chama";
      }
      action.payload.room_name = orgId + "_" + action.payload.branchName + "_counselling_call";
      action.payload.counselling_call = true;
      //console.log("===========Dispense Object==========="+JSON.stringify(action.payload))
      let message1 = new Paho.Message(JSON.stringify(action.payload));
      message1.destinationName = orgId + "_" + action.payload.branchName + "_counselling_call";

      client.send(message1);
      return {
        ...state,
        startVideoCall: action.payload
      };

    case GET_DURINFO:
      return {
        ...state,
        durInfo: action.payload
      };
    case MODAL_PRESCRIPTION_VIEW:

      return {
        ...state,
        presc_modal_view: action.payload,
        is_modal_view: action.payload.isView
      };

    case PRESCRIPTION_LOADING:
      return {
        ...state,
        loading: true
      };
    case PRESCRIPTION_LOADING:
      return {
        ...state,
        loading: true
      };
    case APPROVE_PRESCRIPTION_LOADING:
      return {
        ...state,
        approved_loading: true
      };
    case DISPENSE_PRESCRIPTION_LOADING:
      return {
        ...state,
        dispensed_loading: true
      };
    case UPDATE_DATA:
      return {
        ...state,
        data_update: true
      };
    case GET_PRESCRIPTIONS:

      //console.log("Bharath3--------->New Meesage Arrived"+action.payload.length);
      return {
        ...state,
        prescriptionDetails: action.payload,
        durInfo: {},
        draftPrescriptions: [],
        pendingPrescriptions: [],
        approvedPrescriptions: [],
        dispensedPrescriptions: [],
        loading: false,
        newMessage: {},
        prescriptionByNumber: {},
        prescriptionHistory: [],
        initial_load: false,
        data_update: false
      };

    case GET_APPROVE_PRESCRIPTIONS:
      //console.log("Bharath3--------->New Meesage Arrived"+action.payload.length);
      return {
        ...state,
        durInfo: {},
        approvedPrescriptions: action.payload,
        approved_loading: false
      };

    case GET_DISPENSED_PRESCRIPTIONS:
      return {
        ...state,
        durInfo: {},
        dispensedPrescriptions: action.payload,
        dispensed_loading: false
      };

    case GET_DRAFTED:
      return {
        ...state,
        draftPrescriptions: action.payload,
        loading: false,
        // newMessage: {},
        //prescriptionByNumber: {},
        //prescriptionHistory: [],
        initial_load: false,
        data_update: false
      };
    case GET_PENDINGS:
      return {
        ...state,
        pendingPrescriptions: action.payload,
        loading: false,
        //newMessage: {},
        //prescriptionByNumber: {},
        //prescriptionHistory: [],
        initial_load: false,
        data_update: false
      };
    case GET_APPROVED:
      return {
        ...state,
        approvedPrescriptions: action.payload,
        loading: false,
        //newMessage: {},
        //prescriptionByNumber: {},
        //prescriptionHistory: [],
        initial_load: false,
        data_update: false
      };
    case NEW_MESSAGE:
      return {
        ...state,
        newMessage: action.payload,
        loading: false
      };
    case GET_PRESCRIPTIONS_BY_ID:
      return {
        ...state,
        prescriptionsById: action.payload,
        loading: false
      };
    case GET_PRESCRIPTION_BY_NUMBER:
      return {
        ...state,
        prescriptionByNumber: action.payload,
        durInfo: {},

        loading: false
      };
    case GET_PRESCRIPTION_BY_STATUS:
      return {
        ...state,
        getPrescriptionByStatus: action.payload,
        loading: false
      };
    case DISPENSED_NOTIFICTION:
      return {
        ...state,
        email: action.payload,
        loading: false
      };
    case PRESCRIPTION_ARRIVED:
      //console.log("===========Dispense Prescription in Payload============="+JSON.stringify(action.payload))
      return {
        ...state,
        prescriptionArrived: action.payload,
        loading: false
      };
    case COUNSELLING_PRESCRIPTION_ARRIVED:
      //console.log("===========Dispense Prescription in Payload============="+JSON.stringify(action.payload))
      if (Array.isArray(action.payload)) {

        return {
          ...state,
          getPrescriptionByStatus: action.payload,
          loading: true
        };
      }
      else {
        return {
          ...state,
          getPrescriptionByStatus: [action.payload],
          loading: false
        };
      }

    case GET_DRAFT:
      return {
        ...state,
        drafted: action.payload,
        loading: false
      };
    case GET_PENDING:
      return {
        ...state,
        pending: action.payload,
        loading: false
      };
    case GET_PRESCRIPTION_HISTORY:
      return {
        ...state,
        prescriptionHistory: action.payload,
        loading: false
      };
    default:
      return state;
  }
}
